// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da
/* 
import {
  PRESUPUESTADOR_GET_LISTA_CLIENTE,
} from './constants';

export function getListaCliente() {
  return {
    type: PRESUPUESTADOR_GET_LISTA_CLIENTE,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_GET_LISTA_CLIENTE:
      return {
        ...state,
      };

    default:
      return state;
  }
} */


import {
  PRESUPUESTADOR_GET_LISTA_CLIENTE_BEGIN,
  PRESUPUESTADOR_GET_LISTA_CLIENTE_SUCCESS,
  PRESUPUESTADOR_GET_LISTA_CLIENTE_FAILURE,
  PRESUPUESTADOR_GET_LISTA_CLIENTE_DISMISS_ERROR,
} from './constants';
import axios from 'axios'
import { getEndpoint } from '../../common/backend/endpoints'


export function getListaCliente(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PRESUPUESTADOR_GET_LISTA_CLIENTE_BEGIN,
    });

    const endpoint_clientes = getEndpoint('CLIENTES')
    const { queryString } = args

    const promise = new Promise((resolve, reject) => {
      const query = queryString ? `${queryString}&dinamicPagination=true` : '?dinamicPagination=true'
      const doRequest = axios(endpoint_clientes+'/'+query)
      doRequest.then(
        (res) => {
          dispatch({
            type: PRESUPUESTADOR_GET_LISTA_CLIENTE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PRESUPUESTADOR_GET_LISTA_CLIENTE_FAILURE,
            data: { 
              error: err.response ? err.response.data.message.message : err.message
            },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetListaClienteError() {
  return {
    type: PRESUPUESTADOR_GET_LISTA_CLIENTE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_GET_LISTA_CLIENTE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getListaClientePending: true,
        getListaClienteError: null,
      };

    case PRESUPUESTADOR_GET_LISTA_CLIENTE_SUCCESS:
      // The request is success
      return {
        ...state,
        dataList: action.data,
        getListaClientePending: false,
        getListaClienteError: null,
      };

    case PRESUPUESTADOR_GET_LISTA_CLIENTE_FAILURE:
      // The request is failed
      return {
        ...state,
        getListaClientePending: false,
        getListaClienteError: action.data.error,
      };

    case PRESUPUESTADOR_GET_LISTA_CLIENTE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getListaClienteError: null,
      };

    default:
      return state;
  }
}
